// Turns an axios error into a friendly, status-aware message for end users.
//
// The full context (method, url, status, server detail) is still logged
// separately via describeApiError in ./logger — this module is purely the
// human-facing copy. Keeping every string here makes wording reviewable in one
// place and is the prerequisite for i18n later.
//
// Note: some flows keep their own specific copy (e.g. signup OTP "invalid" /
// "expired", login "invalid username or password"). Those pass explicit text to
// the notification store; this mapper is the generic fallback for everything else.

const GENERIC = 'Something went wrong. Please try again.'

export function errorMessage(error) {
    if (!error) return GENERIC

    // No response: network failure, timeout, or the request never left the browser.
    if (!error.response) {
        return "Can't reach the server. Check your connection and try again."
    }

    const status = error.response.status

    switch (status) {
        case 400:
        case 422:
            return "Some details weren't accepted — please review and try again."
        case 401:
            return 'Your session expired. Please log in again.'
        case 403:
            return "You don't have permission to do that."
        case 404:
            return "We couldn't find what you were looking for."
        case 409:
            return 'That conflicts with something that already exists.'
        case 410:
            return 'That is no longer available.'
        case 429:
            return "You've tried too many times. Please wait a moment and try again."
        default:
            if (status >= 500) {
                return 'Something went wrong on our end. Please try again in a moment.'
            }
            return GENERIC
    }
}

export default errorMessage
